import mixpanel from "mixpanel-browser";

import { mixpanelApiKey } from "../utils/env";

class AnalyticsService {
  init() {
    try {
      mixpanel.init(mixpanelApiKey);
    } catch (error) {
      console.error("Mixpanel failed to initialize:", error);
    }
  }

  identify(id: any) {
    try {
      mixpanel.identify(id);
    } catch (error) {
      console.error("Mixpanel identify failed:", error);
    }
  }

  setEmail(email: any) {
    try {
      mixpanel.register({
        $email: email,
      });
    } catch (error) {
      console.error("Mixpanel setEmail failed:", error);
    }
  }

  track(event: any, props: any, callback: any) {
    try {
      mixpanel.track(event, props, callback);
    } catch (error) {
      console.error("Mixpanel track failed:", error);
    }
  }

  trackSuccess(userName: any, userId: any, academyId: any, country_code: any) {
    this.track(
      "Signup - user signed up succesfuly",
      {
        userName,
        userId,
        academyId,
        country_code,
      },
      () => {}
    );
  }

  trackError(error: any, userName: any) {
    this.track(
      "Signup - user got an error message",
      {
        userName,
        error,
      },
      () => {}
    );
  }
}

export const analyticsService = new AnalyticsService();
